import styled from "styled-components";

export const HeaderLine = styled.div`
  margin-top: 80px;
  margin-bottom: 80px;
  text-align: center;
  font-size: 64px;
  line-height: 1.2;
  font-weight: 700;

  @media (max-width: 640px) {
    font-size: 8.6vw;
    line-height: 9.3vw;
  }

  @media (max-width: 440px) {
    font-size: 10.5vw;
    line-height: 12.7vw;
  }
`;

export const CurveHolder = styled.div`
  top: 40%;
  z-index: 0;
  left: 0;
  right: 0;
  display: block;
  width: 100%;
  position: absolute;
  display: block;
`;

export const CurveImg = styled.img`
  height: auto;
  width: 100%;
`;

export const ResponsiveFluid = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  max-width: 1280px;
  margin: 0 auto;
  position: relative;
  z-index: 0;
`;

export const FlexStretch = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-around;

  @media (min-width: 1012px) {
    margin-right: -24px;
    margin-left: -24px;
  }

  @media (max-width: 775px) {
    flex-direction: column;
  }
`;

export const PriceBox = styled.div`
  padding-right: 24px;
  padding-left: 24px;
  width: 45%;

  @media (min-width: 1012px) {
    margin-bottom: 0;
  }

  @media (max-width: 991px) {
    width: 50%;
  }

  @media (max-width: 775px) {
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
    margin-top: ${(props) => (props.second ? "48px" : "0px")};
  }
`;

export const GradientBox = styled.div`
  background: radial-gradient(
    circle,
    rgba(61, 139, 211, 1) 0%,
    rgb(123 133 255) 48%,
    rgb(141 123 255) 85%,
    rgba(114, 132, 232, 1) 98%
  );
`;

export const HeightFull = styled.div`
  /* padding-top: 32px; */
  padding-bottom: 8px;

  height: 100%;
  text-align: center;
  background-color: white;
`;

export const InnerFlex = styled.div`
  display: flex;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
  box-shadow: 0px 12px 48px rgba(149, 157, 165, 0.3);
`;

export const PriceTopBoxPro = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;
  padding-right: 16px;
  padding-left: 16px;
  /* background-clip: text; */
  /* -webkit-background-clip: text; */
  /* -webkit-text-fill-color: transparent; */
  /* background-image: linear-gradient(90deg,#125f3f,#00DFD8); */
  color: #125f3f;
`;

export const PriceTopBox = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;
  padding-right: 16px;
  padding-left: 16px;
`;

export const PriceName = styled.h2`
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 610;
  margin-top: 0;
  text-align: center;
`;

export const SecondaryText = styled.div`
  margin-bottom: 0;
  line-height: 1.25;
`;

export const BenefitList = styled.ul`
  padding-top: 8px;
  padding-bottom: 8px;
  list-style: none;
  text-align: left;
  padding-right: 48px;
  padding-left: 16px;
  background-color: #fafbfc;
  grow: 1;

  @media (max-width: 991px) {
    padding-right: 32px;
    padding-left: 0px;
  }
`;

export const BenefitItem = styled.li`
  padding-left: 32px;
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
`;

export const SwitchHolder = styled.div`
  display: flex;
  margin-right: 10px;
  align-items: center;
  justify-content: center;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0px")};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : "0px"};
`;

export const GradientSpan = styled.span`
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: ${(props) =>
    `linear-gradient(90deg,${props.startColor},${props.endColor})`};
`;

export const PriceBottomBox = styled.div`
  padding: 24px 16px 16px;
  text-align: center;
  font-size: 20px;
`;

export const Price = styled.h3`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const PriceNumber = styled.h2`
  font-size: 3.5rem;
  line-height: 0.96;
  letter-spacing: -0.025em;
  margin-right: 8px;
  font-weight: 400;
`;

export const Super = styled.sup`
  font-size: 20px;
  margin-right: 4px;
  vertical-align: middle;
  color: #586069;
  top: -0.5em;
  line-height: 0;
  position: relative;
`;

export const PerMonth = styled.div`
  display: block;
`;

export const FadedText = styled.div`
  margin-top: 10px;
  text-align: center;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.4);
  font-size: 16px;
`;

export const DashedDivider = styled.hr`
  border-top: 1px dashed #a9a9aa;
  width: 100%;
  margin-bottom: ${(props) => props.my};
  margin-top: ${(props) => props.my};
`;

export const DemoLink = styled.a`
  font-family: "Inter", sans-serif !important;
  font-weight: 600;
  &:hover {
    text-decoration: underline;
  }
  color: ${(props) => (props.color ? props.color : "#244339")};
`;

export const PlanTag = styled.div`
  ${(props) =>
    props.type === "fill" &&
    `
        width: ${props.width};
        height: 22px;
        font-size: 12px;
        text-align: center;
        border-radius: 30px;
        border: 1px solid #244339;
        color: white;
        background-color: #244339;
        margin-left: 11px;
        p {
          font-family: "Inter", sans-serif !important;
        }
      `}

  ${(props) =>
    props.type === "solid" &&
    `
            width: ${props.width};
            height: 22px;
            font-size: 12px;
            text-align: center;
            border-radius: 30px;
            border: 1px solid #244339;
            color: #244339;
            background-color: white;
            margin-left: 11px;
            p {
              font-family: "Inter", sans-serif !important;
            }
          `}
`;


export const MyListItem = styled.li`
    margin-bottom: 1.5rem;
    flex-direction: row;
    display: flex;
    font-weight: 500;
    justify-content: flex-start;
    align-items: center;

    

    
    
    @media (max-width: 1400px) {
      justify-content: flex-start;
    }
    
    @media (max-width: 700px) {
      justify-content: space-between;
    }
    
    @media (min-width: 1041px) {
      justify-content: space-between;
    }
`